import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-display',
  templateUrl: './menu-display.component.html'
})
export class MenuDisplayComponent implements OnInit {

  public menuTitle: any = 'route';

  constructor(private _router: Router){}

  ngOnInit(): void {
      this.menuTitle = this._router.url.split('?')[0];
  }

}